<template lang="html">
  <menu class="menu" ref="menu">
    <b-link
      ref="Discover"
      class="menu__item"
      :to="{ name: 'DiscoverCapsules' }"
      style="--bgColorItem: #65ddb7;"
    >
      <SvgDiscover />
    </b-link>

    <b-link
      ref="StitchedOutfits"
      :to="{ name: 'StitchedOutfits', params: { username: currentUsername } }"
      class="menu__item"
      style="--bgColorItem: #f54888;"
      exact
    >
      <SvgStitchedOutfits />
    </b-link>

    <b-link
      ref="Wardrobe"
      :to="{ name: 'WardrobeClothes', params: { username: currentUsername } }"
      class="menu__item"
      style="--bgColorItem: #695CE0;"
    >
      <SvgWardrobe />
    </b-link>

    <b-link
      ref="Tailor"
      :to="{ name: 'Tailor', params: { username: currentUsername } }"
      class="menu__item"
      style="--bgColorItem: #FFCC00;"
      exact
    >
      <SvgTailor />
    </b-link>

    <b-link
      v-b-toggle
      href="#sidebar-1"
      @click.prevent
      class="menu__item"
      style="--bgColorItem:#65ddb7;"
    >
      <svg class="icon" viewBox="0 0 24 24">
        <path d="M3.8,6.6h16.4" />
        <path d="M20.2,12.1H3.8" />
        <path d="M3.8,17.5h16.4" />
      </svg>
    </b-link>

    <b-sidebar
      id="sidebar-1"
      bg-variant="unstitched"
      text-variant="light"
      right
      shadow
      backdrop
    >
      <template #header="{ hide }">
        <div class="w-100">
          <b-link class="sidebar-close-link float-left" @click="hide()">
            <i class="pe-7s-close close-icon"></i>
          </b-link>

          <span class="sidebar-title float-right">{{ currentUsername }}</span>
        </div>
      </template>

      <div class="px-3 py-2">
        <nav class="mb-3">
          <b-nav vertical class="sidebar-menu">
            <b-nav-item
              :to="{ name: 'Account', params: { username: currentUsername } }"
              exact
            >
              <i
                class="pe-7s-user sidebar-nav-icon mr-3"
                aria-hidden="true"
                slot="text"
              />
              <span class="sidebar-nav-text">Account</span>
            </b-nav-item>
            <b-nav-item :to="{ name: 'Community' }" exact>
              <i
                class="pe-7s-joy sidebar-nav-icon mr-3"
                aria-hidden="true"
                slot="text"
              />
              <span class="sidebar-nav-text">Community</span>
            </b-nav-item>
            <b-nav-item :to="{ name: 'Blog' }">
              <i
                class="pe-7s-news-paper sidebar-nav-icon mr-3"
                aria-hidden="true"
                slot="text"
              />
              <span class="sidebar-nav-text">Blog</span>
            </b-nav-item>

            <b-nav-item :to="{ name: 'LogOut' }" @click="logoutUser">
              <i
                class="pe-7s-back-2 sidebar-nav-icon mr-3"
                aria-hidden="true"
                slot="text"
              />
              <span class="sidebar-nav-text">Logout</span>
            </b-nav-item>
          </b-nav>
        </nav>
      </div>
    </b-sidebar>

    <div
      class="menu__border"
      ref="menuBorder"
      :class="{ 'zero-opacity': hideMenuBorder }"
    ></div>
  </menu>
</template>

<script>
import SvgDiscover from "./svgs/SvgDiscover";
import SvgStitchedOutfits from "./svgs/SvgStitchedOutfits";
import SvgTailor from "./svgs/SvgTailor";
import SvgWardrobe from "./svgs/SvgWardrobe";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    SvgDiscover,
    SvgStitchedOutfits,
    SvgWardrobe,
    SvgTailor,
  },

  data() {
    return {
      activeIcon: null,
      hideMenuBorder: false,
    };
  },

  mounted() {
    this.$nextTick(this.routeLoaded);
  },

  methods: {
    ...mapActions(["logoutUser"]),

    routeLoaded() {
      const routeName = this.getRoutName();
      const ref = this.$refs[routeName];

      if (ref) {
        this.hideMenuBorder = false;
        let box = ref.$el.getBoundingClientRect();
        this.offsetMenuBorder(box);
      } else {
        this.hideMenuBorder = true;
      }
    },

    getRoutName() {
      if (
        this.$router.currentRoute.name !== null &&
        this.$router.currentRoute.name.toLowerCase().includes("wardrobe")
      ) {
        return "Wardrobe";
      } else if (
        this.$router.currentRoute.name !== null &&
        this.$router.currentRoute.name.toLowerCase().includes("discover")
      ) {
        return "Discover";
      } else {
        return this.$router.currentRoute.name;
      }
    },

    offsetMenuBorder(box) {
      let menuBorder = this.$refs.menuBorder;
      let left =
        Math.floor(
          box.left -
            this.$refs.menu.offsetLeft -
            (menuBorder.offsetWidth - box.width) / 2
        ) + "px";
      menuBorder.style.transform = `translate3d(${left}, 0 , 0)`;
    },
  },

  computed: {
    ...mapGetters(["currentUser"]),

    currentUsername() {
      if (this.currentUser) {
        return this.currentUser.username;
      }
    },
  },

  watch: {
    $route() {
      this.$nextTick(this.routeLoaded);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.sidebar-close-link {
  color: white;
  vertical-align: middle;

  &:hover {
    color: $primary-blue;
  }

  .close-icon {
    font-size: 32px;
  }
}

.sidebar-title {
  color: $primary-accent;
  font-size: 24px;
  font-weight: 400;
  line-height: 36px;
  vertical-align: top;
}

.sidebar-menu {
  .nav-link {
    color: white;

    &:hover {
      color: $primary-accent;
    }

    &.router-link-active {
      color: $primary-accent;
      &:hover {
        color: $primary-accent-darker;
      }
    }

    .sidebar-nav-icon {
      font-size: 18px;
      vertical-align: middle;
    }

    .sidebar-nav-text {
      vertical-align: sub;
    }
  }
}
.menu {
  display: flex;
  // width: 32.05em;
  width: 100%;
  font-size: 1.5em;
  padding: 0 2.85em;
  position: relative;
  align-items: center;
  justify-content: center;
  background-color: var(--bgColorMenu);
  margin-bottom: 0;
}

.menu__item {
  // all: unset;
  flex-grow: 1;
  z-index: 100;
  display: flex;
  cursor: pointer;
  position: relative;
  align-items: center;
  justify-content: center;
  padding: 0.55em 0 0.85em;
  transition: transform var(--duration);
}

.menu__item::before {
  content: "";
  z-index: -1;
  width: 4.2em;
  height: 4.2em;
  border-radius: 50%;
  position: absolute;
  transform: scale(0);
  transition: background-color var(--duration), transform var(--duration);
}

.menu__item.router-link-active {
  transform: translate3d(0, -0.8em, 0);
}

.menu__item.router-link-active::before {
  transform: scale(1);
  background-color: var(--bgColorItem);
}

.icon {
  width: 2.6em;
  height: 2.6em;
  stroke: white;
  fill: transparent;
  stroke-width: 1pt;
  stroke-miterlimit: 10;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 400;
}

.menu__border {
  left: 0;
  bottom: 99%;
  width: 10.9em;
  height: 2.4em;
  position: absolute;
  clip-path: url(#menu);
  background-color: var(--bgColorMenu);
  transition: transform var(--duration);
  opacity: 1;

  &.zero-opacity {
    opacity: 0;
  }
}

.svg-container {
  width: 0;
  height: 0;
}

@media screen and (max-width: 50em) {
  .menu {
    font-size: 0.8em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/MobileNavbar/MobileNavbarMember.vue